export enum TUTOR_TEACH_TYPE_ID {
  CLASS = 1,
  ONE_TO_ONE = 2,
  CAREER = 3
}
